import { render, staticRenderFns } from "./CreatePaniere.vue?vue&type=template&id=7d4e03b2"
import script from "./CreatePaniere.vue?vue&type=script&lang=js"
export * from "./CreatePaniere.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports